import { render, staticRenderFns } from "./default-parameters.vue?vue&type=template&id=41502f3c&"
import script from "./default-parameters.vue?vue&type=script&lang=js&"
export * from "./default-parameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\gw-actions-runner\\_work\\gower-web-core\\gower-web-core\\App.Core.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41502f3c')) {
      api.createRecord('41502f3c', component.options)
    } else {
      api.reload('41502f3c', component.options)
    }
    module.hot.accept("./default-parameters.vue?vue&type=template&id=41502f3c&", function () {
      api.rerender('41502f3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/components/generic/default-parameters.vue"
export default component.exports